import Ajax from './ajax';

const Request = {
    getDictByType(data) {
        return Ajax.postJson('api/sys/dict/getByType',{ 'type': data })
    },
    Login:{
        login(data){
            return Ajax.postJson('api/sys/loginjwt?username='+ data.username + '&password=' + data.password + '&code=' + data.code + '&codeKey=' + data.codeKey)
        }
    },
    Customer: {
        getCustomerList(data){
            return Ajax.postJson('api/code/minfomanage?current='+ data.current, data)
        },
        getHealthList() {
            return Ajax.get('api/code/order/allHealth')
        },
        addInfo(data){
            return Ajax.postJson('api/code/minfomanage/add', data)
        },
        updateInfo(data){
            return Ajax.postJson('api/code/minfomanage/update', data)
        },
        detailInfo(data){
            return Ajax.get('api/code/minfomanage/get/' + data.id )
        },
        getUserList(data) {
            return Ajax.get('api/code/minfomanage/getUserList',data )
        },
        getCasesInfo(data) {
            return Ajax.get('api/code/minfomanage/getCasesInfo',data )
        },
        updateRelation(data) {
            return Ajax.postJson('api/code/minfomanage/updateRelation', data)
        },
        addCases(data) {
            return Ajax.postJson('api/code/minfomanage/addCases', data)
        },
        updateCases(data) {
            return Ajax.postJson('api/code/minfomanage/updateCases', data)
        },
        deleteCases(id) {
            return Ajax.postJson('api/code/minfomanage/deleteCases', id)
        },
        getRole() {
            return Ajax.get('api/code/minfomanage/getRole' )
        }
    },
    Goods: {
        getGoodsList(data){
            return Ajax.postJson('warehouseOut/getPageList?current='+ data.current, data)
        },
        updateInfo(data) {
            return Ajax.postJson('warehouseOut/updateInfo', data)
        },
        deleteData(data) {
            return Ajax.postJson('warehouseOut/deleteData',data)
        },
        detail(data) {
            return Ajax.get('warehouseOut/detail', data)
        }
    },
    Phone: {
        getsms(data){
            return Ajax.postJson('user/phone/getsms', data)
        }
    },
    My: {
        getInfo(){
            return Ajax.get('driver/getInfo')
        },
        updateInfo(data){
            return Ajax.postJson('driver/updateInfo',data)
        },
        getSupplierList(){
            return Ajax.get('driver/getSupplierList')
        }
    },
    Trip: {
        getTripList(data){
            return Ajax.postJson('api/code/trip?current='+ data.current, data)
        },
        getTripDetail(data) {
            return Ajax.get('api/code/trip/detail/' + data)
        },
        addLeave(data) {
            return Ajax.postJson('api/code/trip/add',data)
        },
        share(data) {
            return Ajax.get('api/code/trip/share', data )
        },
    }
};

export default Request;
